/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import './ForChildSwitch.scss';
import { Checkbox } from '../Inputs/Checkbox';

const styles = require('b_')
    .with('for-child-switch');
const inputStyles = require('b_')
    .with('input');

export const ForChildSwitch = ({
    value,
    onChange = (_) => {
    },
}) => {
    const [ selectedValue, setSelectedValue ] = useState(value);
    useEffect(() => {
        setSelectedValue(value);
    }, [value]);

    const onChangeHandler = (e) => {
        const v = e?.target.checked;
        setSelectedValue(v);
        onChange(v);
    };

    return (
        <div className={styles()}>
            <span className={`${styles('checkbox')}`}>
                <Checkbox value={selectedValue} onChange={onChangeHandler} id="forChildSwitch"/>
            </span>
            <span className={`${styles('label')}  ${inputStyles('label')}`}>Услуга для ребенка</span>
        </div>
    );
};
